import React, { forwardRef } from 'react';
import styled from '@emotion/styled';
import { css } from '@emotion/react';
const Picture = forwardRef(({ children, style, ...props }, ref) => {
    if (style === null || style === void 0 ? void 0 : style.objectPosition) {
        console.warn('Picture: do not use object-position on <Picture> but put it on <Image>.');
        delete style.objectPosition;
    }
    if (style === null || style === void 0 ? void 0 : style.objectFit) {
        console.warn('Picture: do not use object-fit on <Picture> but put it on <Image>.');
        delete style.objectFit;
    }
    return (React.createElement(Container, { ...props, style: style, ref: ref }, children));
});
Picture.displayName = 'Picture';
export default Picture;
const Container = styled.picture((props) => css(css `
      position: relative;
    `, props.stretch &&
    css `
        display: flex;
        width: 100%;
        height: 100%;
        flex: 1;
        min-width: 100%;
      `));
